export default __webpack_public_path__ + "static/media/SimpleLineIcons.3ec13a24.ttf";